import React from 'react';
import classnames from 'classnames';
import { fromPairs, map, get } from 'lodash';

import { Form } from 'modules/form';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { insuranceBasicInformationForm as InsuranceBasicInformationForm } from 'ui/views/widgets/insuranceBasicInformationForm';
 *
 * // render
 * <InsuranceBasicInformationForm propName='propValue'/>
 */
export const insuranceBasicInformationForm = ( props ) => {

    const { sectionData } = props;

    const className = classnames( 'ui-insurance-basic-information-form', props.className );

    return (
        <div className={ className }>

            <div className='ui-insurance-basic-information-form__title'>
                <Icon id={ 'basicInfo' } />
                { getLabel( sectionData.title ) }
            </div>

            <Form
                fields={ fromPairs( map( sectionData.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                values={ props.values } // default values
                isValid={ false }
                mode={ props.mode }
                onSubmit={ ( { values, isValid } ) => {

                    if( isValid ) {
                        props.onFormSubmit( {
                            name: values.name,
                            dob: values.dob,
                            email: values.email,
                            isValid: isValid
                        } );
                    } else {
                        
                        props.onFormSubmit( {
                            isValid: isValid
                        } );
                    }
                } }
                submitOnChange={ true }
                    >
                { ( { fields, values, errors, onChange, onSumbit } = {} ) => {

                    return (
                        <form
                            onSubmit={ onSumbit }
                            className='ui-insurance-basic-information-form__form'
                        >
                            { /* fields */ }
                            { map( fields, ( field ) => {
                                
                                return (
                                    <field.view
                                        className='ui-insurance-basic-information-form__form__field'
                                        key={ field.name }
                                        name={ field.name }
                                        required={ field.required }
                                        config={ field.config }
                                        placeholder={ field.placeholder }
                                        label={ field.title }
                                        onChange={ onChange }
                                        value={ values[ field.name ] }
                                        error={ errors[ field.name ] }
                                        options={ get( props.values.options, field.options ) }
                                    />
                                );
                            } ) }

                        </form>
                    );
                } }
            </Form>
        </div>
    );
};

// set display name
insuranceBasicInformationForm.displayName = 'insuranceBasicInformationForm';

// set default props
insuranceBasicInformationForm.defaultProps = {};

// prop types
insuranceBasicInformationForm.propTypes = {};

/************************************************ */

export const insuranceBasicInformationFormPreloader = () => {
    return (
        <div className='ui-insurance-basic-information-form-preloader'>

            <div className='ui-insurance-basic-information-form-preloader__title'>
                <div className='ui-insurance-basic-information-form-preloader__title__icon'></div>
                <div className='ui-insurance-basic-information-form-preloader__title__value'></div>
            </div>

            { map( [ ...Array( 3 ).keys() ], item => {
                return (
                    <div key={ item } className='ui-insurance-basic-information-form-preloader__items'>
                        <div className='ui-insurance-basic-information-form-preloader__items__item'></div>
                        <div className='ui-insurance-basic-information-form-preloader__items__title'></div>
                    </div>
                );
            } ) }

        </div>
    );
};

// set display name
insuranceBasicInformationFormPreloader.displayName = 'insuranceBasicInformationFormPreloader';

// set default props
insuranceBasicInformationFormPreloader.defaultProps = {};

// prop types
insuranceBasicInformationFormPreloader.propTypes = {};
